module.exports = __webpack_public_path__ + "static/media/simulation-select-time-icon.fbd1cf74.svg";